// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__DaWQl","main-image":"Header_main-image__13bsu","btncontainer":"Header_btncontainer__1zPat"};